/* eslint-disable */
import React from "react";
import styles from './MatrixCard.module.css';

const MetricCard = ({
  title,
  value,
  percentage,
  subtitle,
  isPositive = true,
  onClick,
}) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        {/* <span
          className={`${styles.arrow} ${
            isPositive ? styles.up : styles.down
          }`}
        >
          ↗
        </span> */}
      </div>

      <div className={styles.body}>
        <div className={styles.value}>{value}</div>
        <div
          className={`${styles.percent} ${
            isPositive ? styles.positive : styles.negative
          }`}
        >
          {/* {isPositive ? "+" : ""} */}
          {percentage}%
        </div>
      </div>

      <div className={styles.subtitle}>{subtitle}</div>
    </div>
  );
};

export default MetricCard;
